import axios from 'axios'

import * as types from '../mutation-types'
import { createTheParametersOfTheUrl } from '../../plugins/helper'

const doToArrayObject = ({ data: datos }) => {
  const term = []
  Object.keys(datos).forEach(key => {
    term.push({ value: datos[key].id, text: `${datos[key].nombre} (${datos[key].numero})` })
  })

  return term
}

// state
export const state = {
  loading: true,
  bankAccounts: [],
  error: null,
}

// mutations
export const mutations = {
  [types.GET_BANK_ACCOUNTS_START] (state) {
    state.loading = true
    state.bankAccounts = []
    state.error = null
  },

  [types.GET_BANK_ACCOUNTS_SUCCESS] (state, { data }) {
    state.loading = false
    state.bankAccounts = doToArrayObject(data)
    state.error = null
  },

  [types.GET_BANK_ACCOUNTS_ERROR] (state, { error }) {
    state.loading = false
    state.bankAccounts = []
    state.error = error
  },
}

export const actions = {
  async getBankAccounts ({ commit }, payload) {
    try {
      commit(types.GET_BANK_ACCOUNTS_START)
      const href = createTheParametersOfTheUrl(payload)
      const { data } = await axios.get(`/api/administrations/bank_accounts/lists${href}`)

      commit(types.GET_BANK_ACCOUNTS_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_BANK_ACCOUNTS_ERROR, { error: null })
    }
  },
}

// getters
export const getters = {
  loadingBankAccounts: state => state.loading,
  bankAccounts: state => state.bankAccounts,
  errorBankAccounts: state => state.error,
}
